
import 'slick-carousel';
import FilteredCarousel from '~/js/views/general/components/unique-cuisines/FilteredCarousel';
import ResortDescriptions from '~/js/views/general/components/unique-cuisines/data/resortDescriptions';
import VideoPopupPlay from '~/js/modules/video-popup';

const videoPopup = new VideoPopupPlay('js-video-popup');

// Variable Declaration
const reactUniqueCuisines = query('#unique-cuisines');
const $restaurantSlider = $('.js-restaurant-slider');
const $restaurantSliderControls = $restaurantSlider.parent().find('.js-slider-controls');
const $discoverySlider = $('.js-discovery-slider');
const $discoverySliderControls = $discoverySlider.parent().find('.js-slider-controls');

function preloadSlide($slider, currentSlide = 0) {
    const $currentSlide = $slider.$slider.find('.slick-current');
    const $allCloned = $currentSlide.nextAll('.slick-cloned');
    const $currentCloned = $($allCloned[currentSlide]);
    const $prevSlide = $currentSlide.prev();
    const $nextSlide = $currentSlide.next();

    const setDataSrc = ($slide) => {
        $slide.find('[data-src]').each((index, el) => {
            el.src = el.dataset.src;
            delete el.dataset.src;
        });
    };

    setDataSrc($currentSlide);
    setDataSrc($currentCloned);
    setDataSrc($prevSlide);
    setDataSrc($nextSlide);
}

// Initialization restaurant sliders
$restaurantSlider.on('init reInit afterChange', (event, slick, currentSlide) => {
    const i = (currentSlide ? currentSlide : 0) + 1;

    $restaurantSliderControls.find('.counter').text(`${i}/${slick.slideCount}`);
});

$restaurantSlider.on('init reInit afterChange', (event, slick, currentSlide) => {
    preloadSlide(slick, currentSlide);
    // $(slick.$slides[1]).find('.background img').attr('src', $(slick.$slides[1]).find('.background img').data('lazy'));
});

$restaurantSlider.slick({
    lazyLoad: 'ondemand',
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 500,
    appendArrows: $restaurantSliderControls,
    prevArrow: '<span class="prev arrow"></span>',
    nextArrow: '<span class="next arrow"></span>'
});

$restaurantSlider.on('afterChange', (event, slick, currentSlide) => {
    const $imagePrevObj = $restaurantSlider.find(`div[data-slick-index="${currentSlide - 1}"]`).find('.background img');
    const $imageNextObj = $restaurantSlider.find(`div[data-slick-index="${currentSlide + 1}"]`).find('.background img');
    const imagePrevSrc = $imagePrevObj.data('lazy');
    const imageNextSrc = $imageNextObj.data('lazy');

    if (imagePrevSrc !== $imagePrevObj.attr('src')) {
        $imagePrevObj.attr('src', imagePrevSrc);
    }
    if (imageNextSrc !== $imageNextObj.attr('src')) {
        $imageNextObj.attr('src', imageNextSrc);
    }
});

// Initialization discovery sliders
$discoverySlider.on('init reInit afterChange', (event, slick, currentSlide) => {
    const i = (currentSlide ? currentSlide : 0) + 1;

    preloadSlide(slick, currentSlide);

    $discoverySliderControls.find('.counter').text(`${i}/${slick.slideCount}`);
});

$discoverySlider.slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 500,
    appendArrows: $discoverySliderControls,
    prevArrow: '<span class="prev arrow"></span>',
    nextArrow: '<span class="next arrow"></span>'
});

const mealTypes = [...sandals_app.page.mealTypes];
const minimumRates = {...sandals_app.page.minimumRates};
const resortsSummary = {...sandals_app.page.resortsSummary};
const resortsMealTypes = {...sandals_app.page.resortsMealTypes};
const cdnURL = sandals_app.page.cdnURL;

function getCuisines(rstCode) {
    if (!resortsMealTypes.hasOwnProperty(rstCode)) {
        return [];
    }
    const resortMealTypes = resortsMealTypes[rstCode];

    return resortMealTypes.map(mealType => mealType.mealTypeId);
}

function getRstURL(currentURL) {
    const rstURL = {
        inn: 'sandals-inn',
        halcyon: 'halcyon-beach',
        grenada: 'sandals-grenada',
        barbados: 'sandals-barbados'
    };

    return '/' + (currentURL in rstURL ? rstURL[currentURL] : currentURL);
}

function getResortName(currentResortSummary) {
    let rstName = currentResortSummary.resortShortName.replace(/(Sandals\s)|(Beaches\s)/, '');

    rstName = rstName.replace(/\s(Resort|Spa|Beach|&|Golf|Jamaica).*/, '');
    let rstURL = rstName.replace('.', '');

    rstURL = rstURL.replace(/\s/g, '-').toLowerCase();
    rstURL = getRstURL(rstURL);

    return { name: rstName, link: rstURL };
}

function getResortsData() {
    return Object.keys(minimumRates).map(rstCode => {
        const currentResortRates = minimumRates[rstCode];
        const currentResortSummary = resortsSummary[rstCode];
        const resortData = getResortName(currentResortSummary);
        const resort = {
            code: rstCode,
            logo: currentResortSummary.resortShortName.replace(/\s.*/, ''),
            location: currentResortSummary.resortCity + ', ' + currentResortSummary.resortCountry,
            price: currentResortRates.lowest.avgRate,
            image: `${cdnURL}/resorts/resorts/resort-thumbnails/${rstCode.toLowerCase()}.jpg`,
            description: ResortDescriptions[rstCode] && ResortDescriptions[rstCode].shortDescription,
            cuisines: getCuisines(rstCode)
        };

        resort.resortName = resortData.name;
        resort.link = resortData.link;

        return resort;
    });
}

// Render react component
ReactDOM.render(<FilteredCarousel mealTypes={mealTypes} resortsMealTypes={resortsMealTypes} resortsData={getResortsData()} cuisines={mealTypes}/>, reactUniqueCuisines);
